import { useState } from 'react'
import { Button, ButtonGroup, Dropdown } from 'react-bootstrap'
import {
  TAB_DISPLAY_OPTIONS,
  applyTabDisplay,
  disableTablature,
  getTabDisplay,
  getTablatureButtonLabel,
  shouldRenderTablature,
} from '../tablatureConfig'
import TablatureSettingsModal, { tablatureSettingsSummary } from './TablatureSettingsModal'
import { setTuneDisplaySettings } from '../tuneDisplaySettings'

function storeTuneTablatureSettings(tune) {
  if (!tune || !tune.id) return
  setTuneDisplaySettings(tune.id, {
    tablature: tune.tablature,
    tablatureVoices: tune.tablatureVoices,
    tablatureEnabled: tune.tablatureEnabled,
    tabDisplay: tune.tabDisplay,
  })
}

export default function TablatureSelector(props) {
  const { tune, tunebook, onChange, variant, stopMenuClose, className } = props
  const [showModal, setShowModal] = useState(false)
  const [showMenu, setShowMenu] = useState(false)
  if (!tune) return null

  const tabActive = shouldRenderTablature(tune)
  const tabDisplay = getTabDisplay(tune)
  const buttonText = getTablatureButtonLabel(tune)
  const buttonTitle = tabActive
    ? ('Tablature: ' + tablatureSettingsSummary(tune))
    : 'Set tablature instrument and tuning'

  function stop(e) {
    if (!stopMenuClose) return
    e.preventDefault()
    e.stopPropagation()
  }

  function openModal(e) {
    stop(e)
    setShowMenu(false)
    setShowModal(true)
  }

  function turnOff(e) {
    stop(e)
    setShowMenu(false)
    disableTablature(tune)
    storeTuneTablatureSettings(tune)
    if (tune.id && tunebook && tunebook.saveTune) {
      tunebook.saveTune(tune)
    }
    if (onChange) onChange(tune.tablature || '')
  }

  function setDisplayMode(e, mode) {
    stop(e)
    setShowMenu(false)
    applyTabDisplay(tune, mode)
    storeTuneTablatureSettings(tune)
    if (tune.id && tunebook && tunebook.saveTune) {
      tunebook.saveTune(tune)
    }
    if (onChange) onChange(tune.tablature || '')
  }

  const blockClass = 'tablature-selector-block'
    + (variant === 'menu' ? ' tablature-selector-block--menu' : '')
    + (className ? ' ' + className : '')

  const mainButton = (
    <Button
      size="sm"
      variant={tabActive ? 'primary' : 'outline-secondary'}
      className="tablature-selector-btn"
      aria-label={buttonTitle}
      title={buttonTitle}
      onClick={openModal}
    >
      {buttonText}
    </Button>
  )

  return (
    <div
      className={blockClass}
      onClick={stop}
      onMouseDown={stop}
    >
      {tabActive ? (
        <Dropdown
          as={ButtonGroup}
          show={showMenu}
          onToggle={function(next) { setShowMenu(next) }}
          align="end"
        >
          {mainButton}
          <Dropdown.Toggle
            split
            size="sm"
            variant="primary"
            className="tablature-selector-toggle"
            aria-label="Tablature options"
          />
          <Dropdown.Menu
            className="tablature-selector-menu"
            popperConfig={{ strategy: 'fixed' }}
          >
            {TAB_DISPLAY_OPTIONS.map(function(option) {
              const active = tabDisplay === option.value
              return (
                <Dropdown.Item
                  key={option.value}
                  active={active}
                  onClick={function(e) { setDisplayMode(e, option.value) }}
                >
                  {option.label}
                </Dropdown.Item>
              )
            })}
            <Dropdown.Divider />
            <Dropdown.Item onClick={turnOff}>
              Turn off tablature
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ) : mainButton}

      <TablatureSettingsModal
        show={showModal}
        onHide={function() { setShowModal(false) }}
        tune={tune}
        tunebook={tunebook}
        onApply={function() {
          if (onChange) onChange(tune.tablature || '')
        }}
      />
    </div>
  )
}
